var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"export-to-calendar-popover--{{layout}}\">\n<div class=\"text-center calendar-box\">\n<a ng-href=\"{{booking._links.ical.href}}\" target=\"_blank\">\n<img ng-src=\"{{images.outlook}}\" alt=\"\" height=\"30\" width=\"30\"/>\n<div translate=\"CORE.BOOKING_EXPORT.OUTLOOK\"></div>\n</a>\n</div>\n<div class=\"text-center calendar-box\">\n<a ng-href=\"{{booking._links.gcal.href}}\" target=\"_blank\">\n<img ng-src=\"{{images.google}}\" alt=\"\" height=\"30\" width=\"30\"/>\n<div translate=\"CORE.BOOKING_EXPORT.GOOGLE\"></div>\n</a>\n</div>\n<div class=\"text-center calendar-box\">\n<a ng-href=\"{{booking._links.ical.href}}\" target=\"_blank\">\n<img ng-src=\"{{images.ical}}\" alt=\"\" height=\"30\" width=\"30\"/>\n<div translate=\"CORE.BOOKING_EXPORT.ICAL\"></div>\n</a>\n</div>\n</div>";
var id1="javascripts/bl-booking-export/popover_layout.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/bl-booking-export/popover_layout.html
// module id = 1336
// module chunks = 0